import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHookstate } from "@hookstate/core";
import { MAP_GLOBAL_STATES } from "globalStore/globalStore";
import Features from "pages/Admin/Features";
import Users from "pages/Admin/Users";
import Validations from "pages/Admin/Validations";
import Manifest from "pages/Admin/Manifest";
import { SiteSettings } from "pages/Admin/SiteSettings";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";

export const AdminPage = () => {
  const dispatch = useDispatch();
  const { mapSideNavTabState } = useHookstate(MAP_GLOBAL_STATES);
  
  useEffect(() => {
    dispatch(COMMON_SERVICES.getCustomerServiceProfile());
  }, []);

  const sideSubnavAdminData = () => {
    switch (mapSideNavTabState.get()) {
      case "Features":
        return <Features />;
      case "Site Settings":
        return <SiteSettings />;
      case "Users":
        return <Users />;
      case "Validations":
        return <Validations />;
      case "Manifest Viewer":
        return <Manifest />;
      default:
        return <></>;
    }
  };
  return <>{sideSubnavAdminData() && sideSubnavAdminData()}</>;
};
